// constants for event names
export const EVENT_WORKING_TIME_ADD = "timeline_working_time_add";
export const EVENT_WORKING_TIME_SHOW = "timeline_working_time_show";
export const EVENT_WORKING_TIME_EDIT = "timeline_working_time_edit";
export const EVENT_WORKING_TIME_RESUME = "timeline_working_time_resume";
export const EVENT_WORKING_TIME_QUICK_SWITCH = "timeline_working_time_quick_switch";
export const EVENT_WORKING_TIME_DUPLICATE = "timeline_working_time_duplicate";
export const EVENT_WORKING_TIME_DELETED = "timeline_working_time_deleted";
export const EVENT_WORKING_TIME_STATUS_UPDATED = "timeline_working_time_status_updated";

export const EVENT_WORKING_TIME_REQUEST_SHOW = "timeline_working_time_request_show";
export const EVENT_WORKING_TIME_REQUEST_EDIT = "timeline_working_time_request_edit";
export const EVENT_WORKING_TIME_REQUEST_DUPLICATE = "timeline_working_time_request_duplicate";
export const EVENT_WORKING_TIME_NOTICE_SHOW = "timeline_working_time_notice_show";
export const EVENT_WORKING_TIME_NOTICE_ADD = "timeline_working_time_notice_add";
export const EVENT_WORKING_TIME_NOTICE_REQUEST_SHOW = "timeline_working_time_notice_request_show";

export const EVENT_PROJECT_TIME_ADD = "timeline_project_time_add";
export const EVENT_PROJECT_TIME_SHOW = "timeline_project_time_show";
export const EVENT_PROJECT_TIME_EDIT = "timeline_project_time_edit";
export const EVENT_PROJECT_TIME_RESUMED = "timeline_project_time_resumed";
export const EVENT_PROJECT_TIME_QUICK_SWITCH = "timeline_project_time_quick_switch";
export const EVENT_PROJECT_TIME_DUPLICATE = "timeline_project_time_duplicate";
export const EVENT_PROJECT_TIME_SHOW_TASK_DETAILS = "timeline_project_time_show_task_details";
export const EVENT_PROJECT_TIME_DELETED = "timeline_project_time_deleted";
export const EVENT_PROJECT_TIME_STATUS_UPDATED = "timeline_project_time_status_updated";
